module.exports = __webpack_public_path__ + "static/media/icon-video-delay.a3448635.svg";